module.exports = __webpack_public_path__ + "static/img/Saipa_banner3_Far.e16ca14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saipa_banner3_Far.png
// module id = 16
// module chunks = 1